import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const createWorkOrderPriorityFilter = {
  name: "createWorkOrderPriorityFilter" as const,
  input: z.object({
    name: z.string(),
    filters: z.array(AdvancedFilterDataSchema),
    filterGroup: FilterGroupSchema.optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
